import { useEffect, useMemo, useRef, useCallback, useState } from 'react'
import { Form, Popover } from 'antd'
import { ClickAwayListener } from '@mui/material'
import clsx from 'clsx'
import { getApi, getCodeUrl, postApi } from 'src/api'
import { INPUT_TYPE, INPUT_ICON } from 'src/@types/enum'
import { I18NS, PAGE_TYPE } from 'src/utils'
import { RuleModal } from '../ruleModal'
import { RULE_MAP } from 'src/utils/pwdRule'
import s from './input.module.scss'

const { SvgIcon } = livecloud.icons

export function Input(props) {

  const { name, errorTip, title, type } = props
  const [ open, setOpen ] = useState(false)

  const rules = useMemo(() => [
    { required: true, message: errorTip },
    type == INPUT_TYPE.EMAIL ? {
      type:    'email',
      message: I18NS.ENTER_VALID_EMAIL_word
    } : null,
    type == INPUT_TYPE.PHONE ? {
      validator: (rule, value) => {
        let reg = /^1[0-9]\d{9}$/
        if (!reg.test(value)) {
          return Promise.reject(I18NS.ENTER_VALID_PHONE_WORD)
        }
        return Promise.resolve()
      }
    } : null,
    type === INPUT_TYPE.AGAIN_PASSWORD ? ({ getFieldValue }) => ({
      validator(_, value) {
        if (!value || getFieldValue('password') === value) {
          return Promise.resolve()
        }
        return Promise.reject(new Error(I18NS.PASSWORD_NOT_SAME_WORD))
      }
    }) : null,
    type == INPUT_TYPE.PHONE_OR_EMAIL ? {
      validator: (rule, value) => {
        let reg = /^1[0-9]\d{9}$/
        if (!reg.test(value) && !value?.includes('@')) {
          return Promise.reject(I18NS.ENTER_VALID_EMAIL_OR_PHONE_WORD)
        }
        return Promise.resolve()
      }
    } : null
  ].filter(t => t), [ type ])

  return (
    <Form.Item
      dependencies={type === INPUT_TYPE.AGAIN_PASSWORD ? [ 'password' ] : undefined}
      rules={rules}
      className={`${s.formItem} formItem`}
      name={name}
    >
      <CustomInput {...props} setOpen={setOpen} open={open} />
    </Form.Item>

  )
}

function CustomInput({ setOpen, open, name, errorTip, value, title, type, onChange, help, pageType, isForgetPassword, ...args }) {

  const [ showPwd, setShowPwd ] = useState(false)
  const [ pwdValue, setPwdValue ] = useState('')
  const [ rulePopperArr, setRulePopperArr ] = useState([])

  // 是否报错
  const invalid = !!args['aria-invalid']
  const form = Form.useFormInstance()
  const error = form.getFieldError(name)

  const inputType = useMemo(() => {
    if (
      type == INPUT_TYPE.PASSWORD ||
      type == INPUT_TYPE.AGAIN_PASSWORD
    ) {
      return 'password'
    }
    return 'text'
  }, [ type ])

  const maxLength = useMemo(() => {
    if (
      type == INPUT_TYPE.GET_SMS_CODE ||
      type == INPUT_TYPE.GET_EMAIL_CODE ||
      type == INPUT_TYPE.PHONE_OR_EMAIL_CODE
    ) {
      return 6
    }
    return 40
  }, [ type ])

  // 是否是app
  const isApp = () => {
    if (window.screen.width < 800) {
      return true
    } else {
      return false
    }
  }
  // 校验弹窗里的数据
  const getRule = async () => {
    const res = await getApi('/login/page/pwd/getCondition')()
    if (!res.data) return
    const { conditions } = res.data
    const newRule = conditions?.map(t => ({ ...t, pass: false, fun: RULE_MAP?.filter(j => j.name === Number(t.name))[0]?.['fun'] }))
    setRulePopperArr(newRule)
  }
  // 是否显示校验
  const showPopperRule = !isApp() && (isForgetPassword || pageType === PAGE_TYPE.DenserPeriod) && type === INPUT_TYPE.PASSWORD && name !== 'oldPassword' && pwdValue?.length > 0

  useEffect(() => {
    // setOpen(showPopperRule)
    if (showPopperRule) {
      getRule()
    }
  }, [ showPopperRule ])

  // 校验规则是否都满足都满足不开启弹窗
  const newList = rulePopperArr?.map(t => ({
    ...t,
    pass: t.fun(pwdValue)
  }))?.every(t => t.pass)

  return (
    <ClickAwayListener onClickAway={() => type === INPUT_TYPE.PASSWORD && setOpen(false)}>
      <Popover
        trigger='click'
        placement='right'
        content={<RuleModal value={pwdValue} rulePopperArr={rulePopperArr} />}
        open={open && !newList}
      >
        <div
          className={clsx(`${s.loginInput} formInputBox b-fx b-rel`, invalid && s.invalid)}
        >
          <SvgIcon
            className={`${s.icon} formInputIcon`}
            href={INPUT_ICON[type]}
            size={isApp() ? 20 : 17}
          />
          <input
            className='formInput'
            name={name}
            onBlur={() => setOpen(false)}
            value={value || ''}
            autoComplete='new-password'
            // type={isApp() ? (showPwd ? 'text' : inputType) : inputType}
            type={(showPwd ? 'text' : inputType)}
            placeholder={title}
            maxLength={maxLength}
            onChange={useCallback((e) => {
              if (!isApp() && (isForgetPassword || pageType === PAGE_TYPE.DenserPeriod) && type === INPUT_TYPE.PASSWORD && name !== 'oldPassword') {
                setOpen(true)
              }
              setPwdValue(e.target.value)
              onChange(e.target.value)
            }, [])}
            onKeyDown={(e) => {
              // 判断是否按下了回车键
              if (e.code === 'Enter') {
                form.submit()
              }
            }}
          />
          {
            // ((type === INPUT_TYPE.PASSWORD || type === INPUT_TYPE.AGAIN_PASSWORD) && isApp()) &&
            ((type === INPUT_TYPE.PASSWORD || type === INPUT_TYPE.AGAIN_PASSWORD) && (pageType == PAGE_TYPE.DenserPeriod || isForgetPassword)) &&
            <SvgIcon
              href={showPwd ? '#LiveCloud-common-xianshi1' : '#LiveCloud-common-yincang1'}
              size={20}
              className={`${s.icon} passShowHideIcon`}
              onClick={() => setShowPwd(!showPwd)}
            />
          }
          {
            (
              type === INPUT_TYPE.GET_EMAIL_CODE ||
              type === INPUT_TYPE.GET_SMS_CODE ||
              type === INPUT_TYPE.PHONE_OR_EMAIL_CODE
            ) && (
              <GetCode form={form} type={type} />
            )
          }
          {type === INPUT_TYPE.IMG_VERIFY && <ImgVerify />}
          <div className={`${s.errorTip} formInputErrorTip b-abs`}>
            {error?.[0] || ''}
          </div>
        </div>
      </Popover>
    </ClickAwayListener>

  )
}

function GetCode({ form, type }) {

  const [ { second }, setSecond, getNewState ] = livecloud.useStates(() => ({
    second: Number(localStorage.getItem('cutdown'))
  }))
  // 新增页面卸载监听
  useEffect(() => {
    const handleBeforeUnload = () => {
      if (getNewState().second > 0) {
        localStorage.setItem('cutdown', 0)
      }
    }

    window.addEventListener('beforeunload', handleBeforeUnload)
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload)
      // 组件卸载时也清理存储
      if (getNewState().second > 0) {
        localStorage.removeItem('cutdown')
      }
    }
  }, [])

  useEffect(() => {
    onCountdown()
  }, [])

  const sendCode = useMemo(() => (
    livecloud.debounce(async () => {
      if (getNewState().second > 0) return
      // let account
      let params = {}
      // 邮箱
      // if (type === INPUT_TYPE.GET_EMAIL_CODE) {
      //   try {
      //     const { email } = await form.validateFields([ 'email' ])
      //     account = email
      //   } catch (e) { }
      // }
      // // 手机
      // else {
      //   try {
      //     const { user } = await form.validateFields([ 'user' ])
      //     account = user
      //   } catch (e) { }
      // }
      // 三种情况，手机，邮箱，手机或邮箱，手机或邮箱的时候，需要判断是手机还是邮箱
      // 手机的方法
      const { user, email } = form.getFieldValue()
      const setPhoneParams = (account) => {
        params = {
          userId:    user,
          account,
          loginType: 3
        }
      }
      const setEmailParams = (account) => {
        params = {
          userId:    user || email,
          account,
          loginType: 2
        }
      }
      switch (type) {
        case INPUT_TYPE.GET_EMAIL_CODE:
          try {
            const { email } = await form.validateFields([ 'email' ])
            setEmailParams(email)
          } catch (e) { }
          break
        case INPUT_TYPE.PHONE_OR_EMAIL_CODE:
          try {
            const { phoneOrEmail } = await form.validateFields([ 'phoneOrEmail' ])
            if (phoneOrEmail.includes('@')) {
              setEmailParams(phoneOrEmail)
            } else {
              setPhoneParams(phoneOrEmail)
            }
          } catch (e) { }
          break
        default:
          try {
            const { user } = await form.validateFields([ 'user' ])
            setPhoneParams(user)
          } catch (e) { }
          break
      }

      if (!params) return
      // const res = await postApi('/captcha/sendCode')({
      //   account,
      //   loginType: type === INPUT_TYPE.GET_EMAIL_CODE ? 2 : 3
      // })
      const res = await postApi('/captcha/sendCode')(params)
      if (res.data === livecloud.REQUEST_ERROR) return
      setSecond('second', 60)
      localStorage.setItem('cutdown', 60)
      onCountdown()
    }, 200)
  ), [])

  const onCountdown = useCallback(() => {
    const { second } = getNewState()
    let timer
    if (second > 0) {
      timer = setInterval(() => {
        setSecond('second', pre => {
          const next = pre - 1
          localStorage.setItem('cutdown', next)
          if (next <= 0) clearInterval(timer)
          return next
        })
      }, 1000)
    }
  }, [])

  return (
    <div
      className={`${s.getCode} formGetCode`}
      onClick={sendCode}
    >
      {second < 1 ? I18NS.GET_CHECK_CODE_WORD : I18NS.COUNTDOWN_WORD.replace('{0}', second)}
    </div>
  )
}

function noDebounceSetUrl(dom) {
  return dom.src = getCodeUrl()
}

function ImgVerify() {

  const imgRef = useRef()

  useEffect(() => {
    noDebounceSetUrl(imgRef.current)
  }, [])

  const setCodeUrl = useMemo(() => {
    return livecloud.debounce(() => {
      noDebounceSetUrl(imgRef.current)
    }, 200)
  }, [])

  return (
    <img
      id='imgVerify'
      ref={imgRef}
      className={s.imgVerify}
      onClick={setCodeUrl}
    />
  )
}